import React, { useEffect, useState } from 'react';
import { ReactComponent as Pencil } from 'assets/icons/pencil.svg';
import { Modal } from 'components';
import Button from 'components/button';
import { Input } from 'antd';
import { Select } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import { getGroups, getUserData } from 'store/adminPanel/actions';

const ViewModal = ({ isVisible, setVisible, usersId }) => {
    const dispatch = useDispatch();
    const [groups, setGroups] = useState([]);

    useEffect(() => {
        if(usersId){
            dispatch(getUserData(usersId));
        }
    }, [usersId]);

    useEffect(()=>{
        getGroups().then(groups => {
            setGroups(groups.map(item=>item.name));
            }).catch(error => {
            console.error("Error fetching groups:", error);
            });
    },[]);

    const user = useSelector((state => state.adminPanel.selectedUser));
    
    const [userID, setUserID] = useState(user?.id);
    const [userFirstName, setUserFirstName] = useState(user?.firstName);
    const [userLastName, setUserLastName] = useState(user?.lastName);
    const [userEmail, setUserEmail] = useState(user?.email);
    const [userGroup, setUserGroup] = useState(user ? user.groups ? user.groups.map(item=>item.name) : "" : "");
    const [userInfo, setUserInfo] = useState(JSON.stringify(user?.info));
    const [hintJSON, setHintJSON] = useState("");
    const [displayedInfo, setDisplayedInfo] = useState("");

    const checkJSONStructure = str => {
        try {
          JSON.parse(str);
          setHintJSON("");
        } catch (e) {
          setHintJSON(e.name + ": " + e.message);
          return false;
        }
        return true;
    };
    const prettify = value => {
        try {
          if (checkJSONStructure(value)) {
            setHintJSON("");
            const ugly = JSON.parse(value);
            const pretty = JSON.stringify(ugly, undefined, 4);
            return pretty;
          }
        } catch (err) {
          console.log(err);
          setHintJSON(err);
        }
        return value;
    };

    useEffect(()=>{
        if(userInfo){
            setDisplayedInfo(prettify(userInfo));
        }
    },[userInfo])

    useEffect(()=>{
        setUserID(user?.id);
        setUserFirstName(user?.firstName);
        setUserLastName(user?.lastName);
        setUserInfo(JSON.stringify(user?.info));
        setUserEmail(user?.email);
        setUserGroup(user ? user.groups ? user.groups.map(item=>item.name) : "" : "");
    },[user]);

    return (
      <Modal
        isVisible={isVisible}
        // Icon={Pencil}
        submitDisabled={true}
        onCancel={() => setVisible(false)}
        // title={<h1 style={{color:"#2d97e9", marginTop:"0.563rem", marginLeft:"1.875rem"}}>Create User</h1>}
        width={817}
        footer={[
            <Button
              label={'Close'}
              type={'default'}
              onClick={() => setVisible(false)}
            />,
          ]}
          className={'invalid-modal'}
      >
        <div style={{marginTop:"20px"}}>
            <span className='input-titles'>User ID</span>
            <Input style={{height:"40px"}} value={userID} disabled></Input>
        </div>
        <div style={{marginTop:"20px"}}>
            <span className='input-titles'>Email</span>
            <Input style={{height:"40px"}} value={userEmail} disabled></Input>
        </div>
        <div style={{marginTop:"20px", display:"flex"}}>
            <div>
                <span className='input-titles'>First Name</span>
                <Input style={{width:"350px",height:"40px"}} value={userFirstName} disabled></Input>
            </div>
            <div style={{marginLeft:"65px"}}>
                <span className='input-titles'>Last Name</span>
                <Input style={{width:"350px",height:"40px"}} value={userLastName} disabled></Input>
            </div>
        </div>
        <div style={{marginTop:"20px"}}>
            <span className='input-titles'>Group</span>
            <Select
                showSearch={false}
                size="small"
                mode="multiple"
                disabled
                value={userGroup}
                placeholder="No Data"
                onChange={value=>setUserGroup(value)}
                options={groups.map(item => ({
                    label: item,
                    value: item
                  }))}
            />
        </div>
        <div style={{marginTop:"20px"}}>
            <span className='input-titles'>Info</span>
            <Input style={{height:"40px"}} value={displayedInfo} disabled></Input>
        </div>
      </Modal>
    );
  };
  
  export default ViewModal;